export function initPurchaseSticky(): void {
  const purchase = document.querySelector<HTMLElement>(".p-main-product__purchase");
  if (!purchase) return;

  const desktop = window.matchMedia("(min-width: 768px)");
  let frame = 0;

  const apply = () => {
    frame = 0;

    if (!desktop.matches) {
      purchase.classList.remove("is-stuck");
      purchase.scrollTop = 0;
      return;
    }

    const headerHeight =
      parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue("--header-height"),
      ) || 0;
    const stuck = purchase.getBoundingClientRect().top <= headerHeight + 1;

    if (!stuck && purchase.classList.contains("is-stuck")) {
      purchase.scrollTop = 0;
    }

    purchase.classList.toggle("is-stuck", stuck);
  };

  const requestUpdate = () => {
    if (frame) return;
    frame = window.requestAnimationFrame(apply);
  };

  window.addEventListener("scroll", requestUpdate, { passive: true });
  window.addEventListener("resize", requestUpdate);
  desktop.addEventListener("change", requestUpdate);
  window.addEventListener("load", requestUpdate);
  requestUpdate();
}
